import { ProductStickyMobileHeader } from "src/components/product-details/ProductStickyMobileHeader"
import { ProductActivateCouponCode } from "src/components/product-details/buyBox/ProductActivateCouponCode"
import { ProductCategoryFeatures } from "src/components/product-details/buyBox/ProductCategoryFeatures"
import { ProductShippingInfo } from "src/components/product-details/buyBox/ProductShippingInfo"
import { ProductSlogan } from "src/components/product-details/buyBox/ProductSlogan"
import { ProductTiles } from "src/components/product-details/buyBox/ProductTiles"
import { ProductTop } from "src/components/product-details/buyBox/ProductTop"
import { BackInStockSubcriptionButton } from "src/components/product-details/buyBox/backInStock/BackInStockSubcriptionButton"
import { ProductDiscountPill } from "src/components/product-list/ProductDiscountPill"
import { PaymentMethods } from "src/components/styled/PaymentMethods"
import { ShopPerks } from "../ShopPerks"
import { SocialProof } from "../SocialProof"
import { useProductContext } from "../context"
import { ProductAddToCartButton } from "./ProductAddToCartButton"

export const ProductBuyBox = () => {
  const {
    resolvedSku: sku,
    resolvedDiscount: discount,
    resolvedCoupon: coupon,
    resolvedRegularPrice: regularPrice,
    resolvedAvailable: available,
  } = useProductContext()

  return (
    <div className="relative mx-auto grid w-110 max-w-full grid-cols-1 justify-items-center gap-8 rounded-3xl bg-white py-8 xl:border xl:px-4">
      <div className="grid w-full grid-cols-1 justify-items-center gap-8 xl:px-4">
        {available && !!discount && (
          <div className="flex justify-start">
            <ProductDiscountPill discount={discount} coupon={coupon} regularPrice={regularPrice} />
          </div>
        )}

        <ProductTop />
        <ProductSlogan />
        <ProductCategoryFeatures />
        <ProductTiles />

        <div className="border-y py-8">
          <SocialProof />
        </div>

        <div className="relative">
          <ProductStickyMobileHeader />

          <div className="flex flex-col gap-4">
            <ProductAddToCartButton />
            <ProductShippingInfo />
          </div>
        </div>

        {available && <ProductActivateCouponCode />}
        {available && <PaymentMethods />}
        {!available && <BackInStockSubcriptionButton key={sku} sku={sku} />}

        <div className="px-2">
          <ShopPerks />
        </div>
      </div>
    </div>
  )
}
